import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-so-range',
  templateUrl: './so-range.component.html',
  styleUrls: [],
  standalone: false
})
export class SoRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
